import React from 'react';
import { SIGNATURE_INSTRUCTIONS } from './constants';

function InstructionsSection({ isExpanded, onToggle, documentName }) {
  return (
    <div className="mb-6">
      <button
        type="button"
        onClick={onToggle}
        className="w-full flex items-center justify-between p-3 bg-blue-50 hover:bg-blue-100 rounded-lg transition-colors"
        aria-expanded={isExpanded}
      >
        <div className="flex items-center gap-3">
        <svg className="w-5 h-5 text-blue-600" id="Layer_1" enableBackground="new 0 0 32 32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g fill="#231f20"><path d="m16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm0 30c-7.7 0-14-6.3-14-14s6.3-14 14-14 14 6.3 14 14-6.3 14-14 14z"/><path d="m16 13c-1.1 0-2 .9-2 2v7c0 1.1.9 2 2 2s2-.9 2-2v-7c0-1.1-.9-2-2-2z"/><circle cx="16" cy="9" r="2"/></g></svg>
          <div className="text-left">
            <div className="text-sm font-semibold text-gray-900">
              Signing checklist
            </div>
            <div className="text-xs text-gray-600">
              {isExpanded
                ? 'Hide quick steps'
                : `Tap to view steps for ${documentName || 'this document'}`}
            </div>
          </div>
        </div>
        <svg
          className={`w-5 h-5 text-gray-600 transition-transform ${
            isExpanded ? 'rotate-180' : ''
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>
      {isExpanded && (
        <div className="mt-3 pl-2">
          <ol className="space-y-3">
            {SIGNATURE_INSTRUCTIONS.map((step, index) => (
              <li key={step.title} className="flex gap-3">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-500 text-white text-xs font-semibold flex items-center justify-center">
                  {index + 1}
                </span>
                <div>
                  <div className="text-sm font-medium text-gray-900">
                    {step.title}
                  </div>
                  <div className="text-xs text-gray-600 mt-1">
                    {step.description}
                  </div>
                </div>
              </li>
            ))}
          </ol>
        </div>
      )}
    </div>
  );
}

export default InstructionsSection;

